var React = require('react');

function MenuVertical (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M23.974 37.506a3.75 3.75 0 100 7.5 3.75 3.75 0 100-7.5zm-6.75 3.75a6.75 6.75 0 016.75-6.75 6.75 6.75 0 016.75 6.75 6.75 6.75 0 01-6.75 6.75 6.75 6.75 0 01-6.75-6.75zm6.75-38.25a3.75 3.75 0 100 7.5 3.75 3.75 0 100-7.5zm-6.75 3.75a6.75 6.75 0 016.75-6.75 6.75 6.75 0 016.75 6.75 6.75 6.75 0 01-6.75 6.75 6.75 6.75 0 01-6.75-6.75zm6.75 13.5a3.75 3.75 0 100 7.5 3.75 3.75 0 100-7.5zm-6.75 3.75a6.75 6.75 0 016.75-6.75 6.75 6.75 0 016.75 6.75 6.75 6.75 0 01-6.75 6.75 6.75 6.75 0 01-6.75-6.75z"}));
}

MenuVertical.defaultProps = {"viewBox":"0 0 48 49"};

module.exports = MenuVertical;

MenuVertical.default = MenuVertical;
